"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxAudioSize = exports.MinAudioSize = exports.AllowedAudioFiles = exports.AllowedAudioExtensions = void 0;
exports.AllowedAudioExtensions = [
    'audio/x-m4a',
    'audio/mpeg',
    'audio/mp4',
];
exports.AllowedAudioFiles = {
    'audio/x-m4a': 'm4a',
    'audio/mpeg': 'mp4',
    'audio/mp4': 'mp4',
};
exports.MinAudioSize = 10;
exports.MaxAudioSize = 25 * 1024 * 1024;
//# sourceMappingURL=UpdateTranscriptBody.js.map